import React from 'react';
import ReactDOM from 'react-dom';
import OrderDetails from '../components/order-details/OrderDetails.jsx';

ReactDOM.render(<OrderDetails />, document.querySelector('#orderDetailsContainer'));